import transformFilterModelFromV1ToV0 from './transformFilterModelFromV1ToV0';
export default function transformFilterModelFromV1ToV0IfNotYet(filterModel) {
    if (!filterModel) {
        return {};
    }
    else if (Array.isArray(filterModel)) {
        return transformFilterModelFromV1ToV0(filterModel);
    }
    else {
        return filterModel;
    }
}
